import React from "react";
import { MatchHeader, Set, MatchStatus, Match } from "../../store/matches/models";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Tooltip,
  Link,
  IconButton
} from "@material-ui/core";
import { Player } from "../../store/players/models";
import DateTimeView from "../../framework/components/DateTimeView";

import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import LoopIcon from '@material-ui/icons/Loop';
import { firstPlayerWon, secondPlayerWon } from "./utils";
import CommentIcon from '@material-ui/icons/Comment';
import { MatchHeaderWithLeagueInfo } from "../../store/matches/selectors";
import { getConfig } from "../../config/configuration";
import DateView from "../../framework/components/DateView";

interface ScoreDisplayProps {
  sets: Set[];
  isOponentRetired: boolean;
}

const ScoreDisplay: React.FC<ScoreDisplayProps> = ({ sets, isOponentRetired }) => {
  return (
    <>
      {isOponentRetired ? <b>wo</b> : <></>}
      {" "}
      {sets.map((s, i) => (
        <span key={i} style={{ display: "inline-block", marginRight: "16px", whiteSpace: "nowrap" }}>
          {s.firstPlayer}
          {s.tieBreak ? <sup>({s.tieBreak.firstPlayer})</sup> : <></>} :{" "}
          {s.secondPlayer}
          {s.tieBreak ? <sup>({s.tieBreak.secondPlayer})</sup> : <></>}
        </span>
      ))}
    </>
  );
};

interface MatchesTableProps {
  matches: MatchHeaderWithLeagueInfo[];
}

const NewestMatchesInSeason: React.FC<MatchesTableProps> = ({
  matches
}) => {

  const [tenant, setTenant] = React.useState<string>("");

  React.useEffect(() => {

    getConfig().then((c) => {
      setTenant(c.key as string);
    })

  }, [])

  return (
    <>
      <TableContainer key="p1">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Liga</TableCell>
              <TableCell>Data</TableCell>
              <TableCell>Klub</TableCell>
              <TableCell>Zawodnik</TableCell>
              <TableCell>Przeciwnik</TableCell>
              <TableCell>Wynik</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {matches.map(match => (
              <TableRow key={match.id}>
                <TableCell>
                  <Link href={`/#/leagues/${match.league?.year}/${match.league?.id}`}>{match.league?.name}</Link>
                </TableCell>
                <TableCell>
                  {
                    tenant === "gorzow" ? !!match.reportedOn ? (<DateView value={match.reportedOn} />) : (<></>) : <DateTimeView value={match.date}></DateTimeView>
                  }
                </TableCell>
                <TableCell>
                  <span>{match.club.name}</span>
                </TableCell>
                <TableCell>
                  <Link href={`/#/stats/${btoa(match.firstPlayer.id)}`}>
                    <span
                      style={{
                        fontWeight:
                          firstPlayerWon((match as any) as MatchHeader)
                            ? "bolder"
                            : "normal"
                      }}
                    >
                      {match.firstPlayer.name} {match.firstPlayer.surname}
                    </span>
                  </Link>
                </TableCell>
                <TableCell>
                  <Link href={`/#/stats/${btoa(match.secondPlayer.id)}`}>
                    <span
                      style={{
                        fontWeight:
                          secondPlayerWon((match as any) as MatchHeader)
                            ? "bolder"
                            : "normal"
                      }}
                    >
                      {match.secondPlayer.name} {match.secondPlayer.surname}
                    </span>
                  </Link>
                </TableCell>
                <TableCell>
                  <span>
                    {match.score ? (
                      <ScoreDisplay sets={match.score} isOponentRetired={match.isOponentRetired}></ScoreDisplay>
                    ) : (
                        <span>Nierozegrany</span>
                      )}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default NewestMatchesInSeason;